import { Upload } from 'antd'
import { UploadChangeParam } from 'antd/lib/upload'
import { UploadFile } from 'antd/lib/upload/interface'
import React, { useCallback, useState } from 'react'

export type SingleFileUploadData = {
  file: File
  files: File[]
}

export interface Props {
  onChange?: (file: File) => void
}

export const SingleFileUpload: React.FC<Props> = (props) => {
  const { onChange } = props
  const [file, setFile] = useState<UploadFile>()

  const beforeUpload = useCallback(() => false, [])

  const changeHandler = useCallback(
    (param: UploadChangeParam<UploadFile>) => {
      const currentFile =
        param.file.status === 'removed' ? undefined : param.file

      setFile(currentFile)

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onChange?.(currentFile as any)
    },
    [setFile, onChange],
  )

  return (
    <Upload
      multiple={false}
      listType="text"
      fileList={file ? [file] : []}
      beforeUpload={beforeUpload}
      onChange={changeHandler}
    >
      {props.children}
    </Upload>
  )
}
